
import UserAppContext from '../../hook/UserAppContext'
import './load.css'

const Load = () => {

      const {user} = UserAppContext()
      
      if(user.length !== 0) return 

      return (
            <div className="load_content">
                  <div className="load_circle"></div>
                  <span>Wait Loading...</span>
            </div>
      )
}

export default Load
